// import React, { useEffect, useContext } from "react";
// import { ClassicSpinner } from "react-spinners-kit";
// import { AuthenticationState } from "../../App";
// import { AuthenticateUser, FetchHomePageDetails } from "../../api/aws-api";
// import { ConstructorEventPost, ConstructorEventGet } from "../../Event/event";
// import { Link, useNavigate } from "react-router-dom";

// const Authentication = () => {
//   const { setuserAuthenticated, setVerifiedAsMentor, setVerifiedAsAdmin } =
//     useContext(AuthenticationState);
//   const navigate = useNavigate();

//   useEffect(() => {
//     console.log("authentication triggered");
//     const lastLoginTime = localStorage.getItem("lastLoginTime");
//     const authToken = localStorage.getItem("authToken");
//     if (authToken && Date.now() - lastLoginTime < 24 * 60 * 120 * 1000) {
//       CheckStatus(authToken);
//     } else {
//       setuserAuthenticated(false);
//       navigate("/signIn");
//     }
//   }, []);

//   const CheckStatus = async (authToken) => {
//     const storedData = localStorage.getItem("UserKey");
//     if (
//       storedData !== "undefined" &&
//       storedData !== "null" &&
//       storedData !== undefined &&
//       storedData !== null
//     ) {
//       const params = JSON.parse(storedData);
//       fetchdata(JSON.parse(storedData));
//       params["authToken"] = authToken;
//       const responsedata = await ConstructorEventPost(AuthenticateUser, params);

//       console.log("auth triggered");
//       if (responsedata === "authentication_success") {
//         setuserAuthenticated(true);
//       } else if (responsedata === "authentication_failed") {
//         setuserAuthenticated(false);
//         navigate("/signIn");
//       } else {
//         setuserAuthenticated(false);
//         navigate("/signIn");
//       }
//     } else {
//       setuserAuthenticated(false);
//       navigate("/signIn");
//     }
//   };

//   const fetchdata = async (params) => {
//     const responsedata = await ConstructorEventGet(
//       FetchHomePageDetails,
//       params
//     );
//     sessionStorage.setItem("UserData", JSON.stringify(responsedata[0]));
//     checkUserType(responsedata[0]);
//   };

//   function checkUserType(data) {
//     const userType = data && data.user_type;
//     if (userType === "mentor") {
//       setVerifiedAsMentor(true);
//     } else if (userType === "admin") {
//       setVerifiedAsAdmin(true);
//     }
//   }

//   return (
//     <>
//       <div className=" min-h-screen bg-[url('../images/all-img/404-bg.png')] bg-cover bg-no-repeat bg-center">
//         <div className="max-w-[570px] mx-auto flex flex-col items-center text-center justify-center min-h-screen px-4">
//           <img alt="" className="mb-14" />
//           <h2 className=" mb-6">Authenticating</h2>
//           <div className="mb-10">
//             You will be granted entry shortly, please be patient.
//           </div>
//           <button className="btn btn-primary">
//             <ClassicSpinner size={30} color="white" loading={true} />
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Authentication;





































import React, { useContext } from "react";
import { ClassicSpinner } from "react-spinners-kit";
import { AuthenticationState } from "../../App";

// This component is intentionally passive. It does NOT independently verify
// the session or call navigate() — App.js owns exactly one auth-check effect
// (CheckStatus, gated on [location.pathname, userAuthenticated]) and is the
// single source of truth for when to flip userAuthenticated and where to
// navigate.
//
// BUG THIS FIXES: the previous version of this file ran its own separate
// CheckStatus + navigate() cycle, independent of App.js's copy. Both read
// the same localStorage/authToken state and both called navigate() as soon
// as they resolved. Because they ran independently and each could flip
// state the other reacted to, they raced each other across many render
// cycles — which is what froze the tab with "This page isn't responding"
// and made /signIn briefly resolve to /codomo/home (or vice versa) instead
// of settling on the sign-in form.
//
// This screen now does exactly one thing: show a "please wait" state while
// App.js's effect resolves. No fetches, no navigate calls, no race.
const Authentication = () => {
  useContext(AuthenticationState); // kept for future use; not read here on purpose

  return (
    <div className="min-h-screen bg-[url('../images/all-img/404-bg.png')] bg-cover bg-no-repeat bg-center">
      <div className="max-w-[570px] mx-auto flex flex-col items-center text-center justify-center min-h-screen px-4">
        <h2 className="mb-6">Authenticating</h2>
        <div className="mb-10">
          You will be granted entry shortly, please be patient.
        </div>
        <button className="btn btn-primary" disabled>
          <ClassicSpinner size={30} color="white" loading={true} />
        </button>
      </div>
    </div>
  );
};

export default Authentication;














































// import React, { useEffect, useContext } from "react";
// import { ClassicSpinner } from "react-spinners-kit";
// import { AuthenticationState } from "../../App";
// import { AuthenticateUser, FetchHomePageDetails } from "../../api/aws-api";
// import { ConstructorEventPost, ConstructorEventGet } from "../../Event/event";
// import { Link, useNavigate } from "react-router-dom";

// // Guards any promise that might hang forever (e.g. a request that never
// // resolves due to CORS, a misconfigured endpoint, or a dead server) so the
// // UI can always fall back to sign-in instead of freezing indefinitely.
// function withTimeout(promise, ms = 10000) {
//   return Promise.race([
//     promise,
//     new Promise((_, reject) =>
//       setTimeout(() => reject(new Error("Request timed out")), ms)
//     ),
//   ]);
// }


// // In Authentication.jsx:

// const Authentication = () => {
//   const { setuserAuthenticated, setVerifiedAsMentor, setVerifiedAsAdmin } = useContext(AuthenticationState);
//   const navigate = useNavigate();
//   const [checking, setChecking] = useState(true);

//   useEffect(() => {
//     console.log("authentication triggered");
//     const lastLoginTime = localStorage.getItem("lastLoginTime");
//     const authToken = localStorage.getItem("authToken");
//     const userKey = localStorage.getItem("UserKey");
    
//     if (authToken && lastLoginTime && userKey && 
//         userKey !== "undefined" && userKey !== "null") {
//       const timeDiff = Date.now() - parseInt(lastLoginTime);
//       if (timeDiff < 24 * 60 * 120 * 1000) {
//         CheckStatus(authToken);
//       } else {
//         // Session expired
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('lastLoginTime');
//         localStorage.removeItem('UserKey');
//         setuserAuthenticated(false);
//         navigate("/signIn");
//       }
//     } else {
//       setuserAuthenticated(false);
//       navigate("/signIn");
//     }
//   }, []);

//   const CheckStatus = async (authToken) => {
//     const storedData = localStorage.getItem("UserKey");
//     if (storedData && storedData !== "undefined" && storedData !== "null") {
//       try {
//         const params = JSON.parse(storedData);
//         fetchdata(params);
//         params["authToken"] = authToken;

//         const responsedata = await withTimeout(
//           ConstructorEventPost(AuthenticateUser, params)
//         );

//         if (responsedata === "authentication_success") {
//           setuserAuthenticated(true);
//           navigate("/codomo/home"); // ← Explicit navigate
//         } else {
//           localStorage.removeItem('authToken');
//           localStorage.removeItem('lastLoginTime');
//           localStorage.removeItem('UserKey');
//           setuserAuthenticated(false);
//           navigate("/signIn");
//         }
//       } catch (e) {
//         console.warn("[Authentication] CheckStatus failed:", e);
//         localStorage.removeItem('authToken');
//         localStorage.removeItem('lastLoginTime');
//         localStorage.removeItem('UserKey');
//         setuserAuthenticated(false);
//         navigate("/signIn");
//       }
//     } else {
//       setuserAuthenticated(false);
//       navigate("/signIn");
//     }
//   };

// // const Authentication = () => {
// //   const { setuserAuthenticated, setVerifiedAsMentor, setVerifiedAsAdmin } =
// //     useContext(AuthenticationState);
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     console.log("authentication triggered");
// //     const lastLoginTime = localStorage.getItem("lastLoginTime");
// //     const authToken = localStorage.getItem("authToken");
// //     if (authToken && lastLoginTime && Date.now() - lastLoginTime < 24 * 60 * 120 * 1000) {
// //       CheckStatus(authToken);
// //     } else {
// //       setuserAuthenticated(false);
// //       navigate("/signIn");
// //     }
// //   }, []);

// //   const CheckStatus = async (authToken) => {
// //     const storedData = localStorage.getItem("UserKey");
// //     if (
// //       storedData !== "undefined" &&
// //       storedData !== "null" &&
// //       storedData !== undefined &&
// //       storedData !== null
// //     ) {
// //       try {
// //         const params = JSON.parse(storedData);
// //         fetchdata(JSON.parse(storedData)); // fire-and-forget; failures handled inside fetchdata itself
// //         params["authToken"] = authToken;

// //         // FIX: previously this had no try/catch and no timeout. If
// //         // AuthenticateUser failed, hung, or never responded, the await
// //         // never resolved and the UI stayed stuck on "Authenticating"
// //         // forever — which is what was freezing/crashing the browser.
// //         const responsedata = await withTimeout(
// //           ConstructorEventPost(AuthenticateUser, params)
// //         );

// //         console.log("auth triggered");
// //         if (responsedata === "authentication_success") {
// //           setuserAuthenticated(true);
// //         } else {
// //           // covers "authentication_failed" and any other unexpected shape
// //           setuserAuthenticated(false);
// //           navigate("/codomo/home");
// //         }
// //       } catch (e) {
// //         // Network error, CORS failure, timeout, bad JSON — whatever it is,
// //         // don't hang. Fall back to sign-in so the page always resolves.
// //         console.warn("[Authentication] CheckStatus failed:", e);
// //         setuserAuthenticated(false);
// //         navigate("/signIn");
// //       }
// //     } else {
// //       setuserAuthenticated(false);
// //       navigate("/signIn");
// //     }
// //   };

//   const fetchdata = async (params) => {
//     try {
//       const responsedata = await withTimeout(
//         ConstructorEventGet(FetchHomePageDetails, params)
//       );
//       sessionStorage.setItem("UserData", JSON.stringify(responsedata[0]));
//       checkUserType(responsedata[0]);
//     } catch (e) {
//       console.warn("[Authentication] fetchdata failed:", e);
//       // Non-fatal — home page details failing shouldn't block auth status itself
//     }
//   };

//   function checkUserType(data) {
//     const userType = data && data.user_type;
//     if (userType === "mentor") {
//       setVerifiedAsMentor(true);
//     } else if (userType === "admin") {
//       setVerifiedAsAdmin(true);
//     }
//   }

//   return (
//     <>
//       <div className=" min-h-screen bg-[url('../images/all-img/404-bg.png')] bg-cover bg-no-repeat bg-center">
//         <div className="max-w-[570px] mx-auto flex flex-col items-center text-center justify-center min-h-screen px-4">
//           <img alt="" className="mb-14" />
//           <h2 className=" mb-6">Authenticating</h2>
//           <div className="mb-10">
//             You will be granted entry shortly, please be patient.
//           </div>
//           <button className="btn btn-primary">
//             <ClassicSpinner size={30} color="white" loading={true} />
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Authentication;



























// import React, { useContext } from "react";
// import { ClassicSpinner } from "react-spinners-kit";
// import { AuthenticationState } from "../../App";

// // This component is intentionally passive. It does NOT independently verify
// // the session or call navigate() — App.js owns exactly one auth-check effect
// // (CheckStatus, gated on [location.pathname, userAuthenticated]) and is the
// // single source of truth for when to flip userAuthenticated and where to
// // navigate.
// //
// // BUG THIS FIXES: the previous version of this file ran its own separate
// // CheckStatus + navigate() cycle, independent of App.js's copy. Both read
// // the same localStorage/authToken state and both called navigate() as soon
// // as they resolved. Because they ran independently and each could flip
// // state the other reacted to, they raced each other across many render
// // cycles — which is what froze the tab with "This page isn't responding"
// // and made /signIn briefly resolve to /codomo/home (or vice versa) instead
// // of settling on the sign-in form.
// //
// // This screen now does exactly one thing: show a "please wait" state while
// // App.js's effect resolves. No fetches, no navigate calls, no race.
// const Authentication = () => {
//   useContext(AuthenticationState); // kept for future use; not read here on purpose

//   return (
//     <div className="min-h-screen bg-[url('../images/all-img/404-bg.png')] bg-cover bg-no-repeat bg-center">
//       <div className="max-w-[570px] mx-auto flex flex-col items-center text-center justify-center min-h-screen px-4">
//         <h2 className="mb-6">Authenticating</h2>
//         <div className="mb-10">
//           You will be granted entry shortly, please be patient.
//         </div>
//         <button className="btn btn-primary" disabled>
//           <ClassicSpinner size={30} color="white" loading={true} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Authentication;